module.exports = __webpack_public_path__ + "img/code-dr.3025fe9e.jpg";